import type { TranslateFunction } from '@locus-taxy/encore-i18n-toolkit';

/** Gender select options for the profile form, with localized labels. */
export function getGenderOptions(t: TranslateFunction) {
  return [
    { label: t('dashboard.userDetails.gender.male', 'Male'), value: 'MALE' },
    {
      label: t('dashboard.userDetails.gender.female', 'Female'),
      value: 'FEMALE',
    },
  ];
}

export const PHOTO_MAX_SIZE_BYTES = 1_048_576; // 1MB
export const PHOTO_ACCEPTED_TYPES = ['image/jpeg', 'image/png'];
